var styles = {"recoCarouselHeader":"RecommendationsCarousel-module_recoCarouselHeader__-xxkR","recommendationsCarousel":"RecommendationsCarousel-module_recommendationsCarousel__gvV47","carousel":"RecommendationsCarousel-module_carousel__xq8bW","carouselSlide":"RecommendationsCarousel-module_carouselSlide__aohDL"};

export { styles as default };
//# sourceMappingURL=RecommendationsCarousel.module.scss.js.map
